import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type LoginFormRows = {
  label: string;
  id: vp.SecurityQuestionId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

const buildLoginFormRows = (): LoginFormRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'OnlineBanking' });
  return [
    {
      label: `${t('answerLabel')}`,
      id: vp.SecurityQuestionId.Answer,
      required: true,
      preset: 'text',
    },
  ];
};

export default buildLoginFormRows;
